import React from "react"
import { RoundedRectangle } from "../atoms/roundedrectangle/RoundedRectangle"
import { RRIconBar } from "../atoms/roundedrectangle/RRIconBar"
import L10n from "../../../lib/carrot-l10n"
import { RRButtonFooter } from "../atoms/roundedrectangle/RRButtonFooter"
import { H3 } from "@carrotfertility/carotene"
import { BodySmall } from "../atoms/Bodies"
import { useSelector } from "react-redux"
import { getBenefitConfiguration } from "../../../reducers/benefitConfiguration"
import { buildMultiElementListString } from "../../../utils/copy/buildMultiElementListString"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const featureCopy = [
  {
    text: "adoption",
    filter: (c) => c.featureConfig.isAdoptionEnabled
  },
  {
    text: "gestational carrier services",
    filter: (c) => c.featureConfig.isGcEnabled
  },
  {
    text: "male fertility services"
  }
]

function LookingForOtherServicesModule() {
  const benefitConfiguration = useSelector(getBenefitConfiguration)
  const filteredFeatureCopy = featureCopy
    .filter((c) => !c.filter || c.filter(benefitConfiguration))
    .map((item) => item.text)
  return (
    <RoundedRectangle backgroundColor="light-gray">
      <RRIconBar iconName="icn-find" iconBackgroundColor="white-60" />
      <H3 variant="primary" stack="tiny">
        {"Looking for "}
        {buildMultiElementListString(filteredFeatureCopy, "or", false)}?
      </H3>
      <BodySmall>{l`weHaveAListOfProviders`}</BodySmall>
      <RRButtonFooter outline to="/talk-to-carrot/sendmessage/otherprovidertype">
        {l`contactUs`}
      </RRButtonFooter>
    </RoundedRectangle>
  )
}

export { LookingForOtherServicesModule }
